if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return; // Exit early if form doesn't exist
        
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        
        if (!this.submitButton) return; // Exit early if submit button doesn't exist
        
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Novatize [START] : Add B2B cart properties if not already present
        this.addB2BProperties(formData);
        // Novatize [END]
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (!this.submitButton) return;
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          // Novatize [START] : Update cart section after adding product to cart from the product page
          .then(() => {
            const novaMainCartSelector = '.nova-main-cart';

            if(document.querySelector(novaMainCartSelector)) {
              const sectionUrl = `/?section_id=nova-main-cart`;

              fetch(sectionUrl)
                .then((response) => response.text())
                .then((text) => {
                  const sectionInnerHTML = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector(novaMainCartSelector);
                  document.querySelector(novaMainCartSelector).innerHTML = sectionInnerHTML.innerHTML;
                })
                .catch((e) => {
                  console.error(e);
                });
            }

            // Update quick order list after adding product to cart from the product page
            const novaQuickOrderList = '.nova-quick-order-list-container';

            if(document.querySelector(novaQuickOrderList)) {
              const sectionUrl = `/?section_id=nova-quick-order-list`;

              fetch(window.location.pathname + sectionUrl)
                .then((response) => response.text())
                .then((text) => {
                  const sectionInnerHTML = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector(novaQuickOrderList);
                    // Novatize [START] : Update quick order list section after adding product to cart from the product page
                    // If the quick order list is not present, just update the cart section
                    if(!document.querySelector('nova-b2b-prices-product-info')) {
                      document.querySelector(novaQuickOrderList).innerHTML = sectionInnerHTML.innerHTML;
                      return;
                    }

                    const variantId = formData.get('id');
                    if(!variantId) return;

                    // Update the quick order list with the new data using cherry-picked data (to avoid overriding the fidelio updated price for B2B users)
                    const newSectionVariantTotals = sectionInnerHTML.querySelectorAll(`#Variant-${variantId} .variant-item__totals`);

                    if(newSectionVariantTotals.length > 0) {
                      document.querySelectorAll(`#Variant-${variantId} .variant-item__totals`).forEach((item,i) => {
                        item.innerHTML= newSectionVariantTotals[i].innerHTML;
                      });
                    }

                    const newSectionVariantQty = sectionInnerHTML.querySelector(`#Variant-${variantId} .variant-item__quantity .quantity__input`);
                    const originalSectionVariantQty = document.querySelector(`#Variant-${variantId} .variant-item__quantity .quantity__input`);
                    if (newSectionVariantQty && originalSectionVariantQty) {
                      originalSectionVariantQty.value = newSectionVariantQty.value;
                      originalSectionVariantQty.setAttribute('data-cart-quantity', newSectionVariantQty.value);
                    }

                    const newSectionTotalItems = sectionInnerHTML.querySelector('.quick-order-list__total-items');
                    const originalSectionTotalItems = document.querySelector('.quick-order-list__total-items');
                    if (newSectionTotalItems && originalSectionTotalItems) {
                      originalSectionTotalItems.innerHTML = newSectionTotalItems.innerHTML;
                    }

                    const newSectionSubtotal = sectionInnerHTML.querySelector('.quick-order-list-total__price');
                    const originalSectionSubtotal = document.querySelector('.quick-order-list-total__price');
                    if (newSectionSubtotal && originalSectionSubtotal) {
                      originalSectionSubtotal.innerHTML = newSectionSubtotal.innerHTML;
                    }
                    // Novatize [END] : Update quick order list section after adding product to cart from the product page
                })
                .catch((e) => {
                  console.error(e);
                });
            }
          })
          // Novatize [END] 
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }

      // Novatize [START] : Add B2B cart properties to form data
      addB2BProperties(formData) {
        // Check if B2B properties are already in the form
        if (formData.has('properties[_company_transport_code]') && formData.has('properties[_company_overload_fees]')) {
          return; // Already present
        }

        // Try to get B2B properties from the form or from hidden inputs in the document
        const transportCodeInput = (this.form && this.form.querySelector('input[name="properties[_company_transport_code]"]')) 
          || document.querySelector('input[name="properties[_company_transport_code]"]');
        const overloadFeesInput = (this.form && this.form.querySelector('input[name="properties[_company_overload_fees]"]'))
          || document.querySelector('input[name="properties[_company_overload_fees]"]');

        if (transportCodeInput && overloadFeesInput) {
          formData.append('properties[_company_transport_code]', transportCodeInput.value);
          formData.append('properties[_company_overload_fees]', overloadFeesInput.value);
        }
      }
      // Novatize [END]
    }
  );
}
